import { useMemo } from 'react'
import { Box, IconButton, Paper, Popper, Typography } from '@mui/material'
import { CloseIcon } from '../../../assets/icons'
import { ContactPhone } from '@prisma/client'
import { trpc } from '../../../core/trpc'
import { toast } from 'react-hot-toast'
import PhoneRow from './PhoneRow'

type ContactPhonePopperProps = {
  name: string
  phones: ContactPhone[]

  anchorEl: HTMLElement | null
  onRequestClose: () => void

  handleCall: ({ phoneNumber, id }: { phoneNumber: string; id: string; thumbsUp: number; thumbsDown: number }) => void
  setOpenPhoneNote: (x: string | null) => void

  onUpdatePhone?: () => void
}

const ContactPhonePopper = ({ name, phones, anchorEl, onRequestClose, handleCall, setOpenPhoneNote, onUpdatePhone }: ContactPhonePopperProps) => {
  const editContactPhoneMutation = trpc.contactPhone.updatePhone.useMutation()

  const sortedPhones = useMemo(() => {
    return (
      phones
        // .map((phone) => ({
        //   ...phone,
        //   is_primary_phone: phone.id === phoneId
        // }))
        .sort((a, b) => {
          if (a.is_primary_phone) return -1
          if (b.is_primary_phone) return 1
          return a.phone_number.localeCompare(b.phone_number)
        })
    )
  }, [phones])

  const updatePrimaryPhone = async (phoneId: string) => {
    try {
      if (!phoneId) return

      // we don't have an endpoint for updating multiple phones at once, so we have to update them one by one
      const updatePromises = phones.map((phone) => {
        return editContactPhoneMutation.mutateAsync({
          phoneId: phone.id,
          isPrimaryPhone: phone.id === phoneId
        })
      })

      await Promise.all(updatePromises)
      onUpdatePhone && onUpdatePhone()
      toast.success('Primary phone number updated successfully')
    } catch (error) {
      toast.error(`Failed to update primary phone number: ${error}`)
    }
  }

  return (
    <Popper className="z-[2000]" open={Boolean(anchorEl)} anchorEl={anchorEl} placement="bottom-start">
      <Paper className="w-[550px] p-5 shadow-md mt-1">
        <Box className="flex justify-between items-center mb-6">
          <Typography className="text_lg_semibold text-grey-900">{name}</Typography>
          <IconButton onClick={onRequestClose}>
            <CloseIcon fontSize="small" className="text-grey-700" />
          </IconButton>
        </Box>
        <Box className="flex flex-col gap-3">
          {sortedPhones.map((item) => (
            <PhoneRow
              isPopper={true}
              key={`${item.id}-${item.is_primary_phone}`}
              type="both"
              num={item}
              name={undefined}
              handleCall={() => handleCall({ phoneNumber: item.phone_number, id: item.id, thumbsUp: item.thumbs_up, thumbsDown: item.thumbs_down })}
              setOpenNote={setOpenPhoneNote}
              onMarkAsPrimary={() => updatePrimaryPhone(item.id)}
            />
          ))}
        </Box>
      </Paper>
    </Popper>
  )
}

export default ContactPhonePopper
